module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('time-usage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'timeUsage'),
      expression: "selectedItem === 'timeUsage'"
    }]
  }), _vm._v(" "), _c('time-usage-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'timeUsageSkills'),
      expression: "selectedItem === 'timeUsageSkills'"
    }]
  }), _vm._v(" "), _c('employee-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeeRevenue'),
      expression: "selectedItem === 'employeeRevenue'"
    }]
  }), _vm._v(" "), _c('efficiency-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'efficiencyGraph'),
      expression: "selectedItem === 'efficiencyGraph'"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c993686"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/employees/learning.vue
// module id = 916
// module chunks = 0